import React, { useCallback, useEffect, useState } from "react";
import {
  AddButton,
  FormItemLabel,
  FormItemLabelWrap,
  FormItemSmallLabel,
  FormItemWrap,
  FormLabelWrap,
  Input,
  LinkButtonWrap,
  OptionLabel,
  OptionSelect,
  OptionValue,
  RequiredLabel,
  Section,
  SelectedItem,
  StateItemLabel,
  StateItemWrap,
  StateLabel,
  StyledButton,
  TextArea,
  TitleLabel,
  VariantType,
} from "./elements";
import { useLocation } from "react-router-dom";
import { upload, getPresignedUrl } from "../../api/s3/upload";
import { sendMail } from "../../api/sendForm";
import { PurchaseData } from "../../api/mockData";
import { checkFileSize } from "../../Utils/validate/fileSize";

const newItem: TargetItem = {
  condition: "",
  gb: "",
  name: "",
  series: "",
};

const getConditionText = (currentState: any) => {
  switch (currentState) {
    case "noScratches":
      return "使用感が少なく傷はない";
    case "someScratches":
      return "使用感はあるが目立つ傷はない";
    case "noticeableScratches":
      return "目立つ傷がある";
    case "crackedScreen":
      return "画面割れ・機能ジャンク品";
  }
};

export const PurchasedForm: React.FC = React.memo(() => {
  const { state } = useLocation();
  const [targetItemCount, setTargetItemCount] = useState(0);
  const [selectedSeries, setSelectedSeries] = useState("");
  const [selectedModel, setSelectedModel] = useState("");
  const [selectedSpec, setSelectedSpec] = useState("");
  const initialState = state
    ? {
        series: state.series,
        name: state.name,
        gb: state.gb,
        condition: getConditionText(state.condition),
      }
    : {
        series: null,
        name: null,
        gb: null,
        condition: undefined,
      };
  const [targetItem, setTargetItem] = useState<TargetItem[]>([initialState]);
  const [fileName1, setFileName1] = useState<string>("");
  const [targetSeries, setTargetSeries] = useState<any | undefined>();
  const [targetData1, setTargetData] = useState<any | undefined>();
  const [targetSpec1, setTargetSpec] = useState<any | undefined>();
  const condition = [
    "noScratches",
    "someScratches",
    "noticeableScratches",
    "crackedScreen",
  ];
  const [fileName2, setFileName2] = useState<string>("");
  const [file1, setFile1] = useState<File | null>(null);
  const [file2, setFile2] = useState<File | null>(null);
  const [isLoading, setIsLoading] = useState<boolean>(false);
  const targetData = PurchaseData.find(
    (item) => item.series === selectedSeries
  );

  const targetSpec = targetData?.model.find(
    (item) => item.name === selectedModel
  );

  const handleAddCount = useCallback(() => {
    setTargetItem((prevTargetItem) =>
      prevTargetItem ? [...prevTargetItem, newItem] : [newItem]
    );
    setTargetItemCount(targetItemCount + 1);
    setTargetSeries(null);
    setTargetData(null);
    setTargetSpec(null);
    setTargetSeries(PurchaseData);
  }, [
    targetItemCount,
    setTargetItemCount,
    setTargetSeries,
    setTargetData,
    setTargetSpec,
  ]);

  const handleSelectedSeries = useCallback(
    (value: string, index: number) => {
      setSelectedSeries(value);
    },
    [setSelectedSeries]
  );

  const handleSelectedModel = useCallback(
    (value: string, index: number) => {
      setSelectedModel(value);
      setTargetItem((prevTargetItem) => {
        if (prevTargetItem) {
          return prevTargetItem.map((item, i) => {
            if (i === index) {
              return { ...item, name: value };
            }
            return item;
          });
        }
        return prevTargetItem;
      });
    },
    [setSelectedModel, setTargetItem]
  );

  const handleSelectedSpec = useCallback(
    (value: string, index: number) => {
      setSelectedSpec(value);
      setTargetItem((prevTargetItem) => {
        if (prevTargetItem) {
          return prevTargetItem.map((item, i) => {
            if (i === index) {
              return { ...item, gb: value };
            }
            return item;
          });
        }
        return prevTargetItem;
      });
    },
    [setSelectedSpec, setTargetItem]
  );

  const handleSelectedCondition = useCallback(
    (value: string, index: number) => {
      setTargetItem((prevTargetItem) => {
        if (prevTargetItem) {
          return prevTargetItem.map((item, i) => {
            if (i === index) {
              return { ...item, condition: value };
            }
            return item;
          });
        }
        return prevTargetItem;
      });
    },
    [setTargetItem]
  );

  useEffect(() => {
    initEvent();
  }, []);

  useEffect(() => {
    setTargetSeries(PurchaseData);
    setTargetData(targetData);
    setTargetSpec(targetSpec);
  }, [targetData, targetSpec]);

  /** file用inputのチェンジイベント */
  const initEvent = (): void => {
    const fileInput1 = document.getElementById("file1") as HTMLInputElement;
    const fileInput2 = document.getElementById("file2") as HTMLInputElement;

    fileInput1?.addEventListener("change", (e: Event) => {
      const target = e.target as HTMLInputElement;
      if (target.files && target.files.length > 0) {
        const selectedFile = target.files[0];
        setFileName1(`1_${selectedFile.name}`);
        setFile1(selectedFile);
      }
    });

    fileInput2?.addEventListener("change", (e: Event) => {
      const target = e.target as HTMLInputElement;
      if (target.files && target.files.length > 0) {
        const selectedFile = target.files[0];
        setFileName2(`2_${selectedFile.name}`);
        setFile2(selectedFile);
      }
    });
  };

  /** フォームパラメーター取得 */
  const getParams = (): SendMailParameter => {
    const params: SendMailParameter = {
      furigana: getValue("furigana") as string,
      name: getValue("name") as string,
      email: getValue("email") as string,
      phoneNumber: getValue("phone_number") as string,
      purchaseItems: targetItem,
      remarks: getValue("remarks") as string,
      occupation: getValue("occupation") as string,
      age: getValue("age") as number,
      postCode: getValue("post_code") as string,
      address: getValue("address") as string,
      pickupDate: getValue("pickup_date") as string,
      pickupTime: getValue("pickup_time") as string,
      bankName: getValue("bank_name") as string,
      branchName: getValue("branch_name") as string,
      depositType: getValue("deposit_type") as string,
      accountNumber: getValue("account_number") as number,
      LineAccount: getValue("line_account") as string,
      filePath: [],
    };

    return params;
  };

  /** 指定キーのvalue取得 */
  const getValue = (id: string): string | number | null => {
    const target = document.getElementById(id) as HTMLInputElement;
    return target?.value || null;
  };

  /** 送信ボタンのClickEvent用メール送信処理 */
  const send = async () => {
    try {
      setIsLoading(true);
      const params = getParams();
      if (!params.email) {
        alert("メールアドレスは入力必須です。");
        setIsLoading(false);
        return;
      }

      let fileSet1: FileTypeSet = {} as FileTypeSet;
      let fileSet2: FileTypeSet = {} as FileTypeSet;
      if (file1) {
        fileSet1 = { fileName: fileName1, mimeType: file1.type };
        if (checkFileSize(file1)) {
          alert(
            "身分証1のサイズが大きすぎます。ファイルサイズは5MB以下で選択してください。"
          );
          setIsLoading(false);
          return;
        }
      }
      if (file2) {
        fileSet2 = { fileName: fileName2, mimeType: file2.type };
        if (checkFileSize(file2)) {
          alert(
            "身分証2のサイズが大きすぎます。ファイルサイズは5MB以下で選択してください。"
          );
          setIsLoading(false);
          return;
        }
      }
      const presignedUrls = await getPresignedUrl(
        params.email,
        fileSet1,
        fileSet2
      ).catch((error: any) => {
        throw new Error(error);
      });

      const uploadPromises = [];

      if (presignedUrls) {
        if (file1 && presignedUrls.url1) {
          const uploadPromise1 = upload(presignedUrls.url1, file1, file1.type)
            .then((filePath) => {
              return filePath || "";
            })
            .catch((error: any) => {
              throw new Error(error);
            });
          uploadPromises.push(uploadPromise1);
        }

        if (file2 && presignedUrls.url2) {
          const uploadPromise2 = upload(presignedUrls.url2, file2, file2.type)
            .then((filePath) => {
              return filePath || "";
            })
            .catch((error: any) => {
              throw new Error(error);
            });
          uploadPromises.push(uploadPromise2);
        }
      }

      const filePaths = await Promise.all(uploadPromises);
      params.filePath.push(...filePaths.filter((path) => path));

      // メール送信
      const result = await sendMail(params);
      if (result) {
        alert("送信が完了しました。");
        setIsLoading(false);
      } else {
        throw new Error("Failed Send Mail");
      }
    } catch (error) {
      console.error(error);
      alert("送信に失敗しました。");
      setIsLoading(false);
    }
  };

  const ageOptions = Array.from({ length: 83 }, (_, index) => ({
    value: index + 18,
    label: `${index + 18}歳`,
  }));

  const pickupTimes = [
    "指定なし",
    "8:00～13:00",
    "14:00～16:00",
    "16:00～18:00",
    "18:00～21:00",
  ];

  return (
    <Section>
      <SelectedItem>
        {targetItem.map((item, index: number) => {
          return (
            <SelectedItem key={`model-${index}`}>
              <StateLabel>{`端末${index + 1}`}</StateLabel>
              {/* 機種 */}
              <StateItemLabel>機種：</StateItemLabel>
              <StateItemWrap variant={VariantType.Medium}>
                {item.name}
              </StateItemWrap>
              {/* 容量 */}
              <StateItemLabel>容量：</StateItemLabel>
              <StateItemWrap variant={VariantType.Medium}>
                {item.gb}
              </StateItemWrap>
              {/* 状態 */}
              <StateItemLabel>状態：</StateItemLabel>
              <StateItemWrap variant={VariantType.Medium}>
                {item.condition}
              </StateItemWrap>
            </SelectedItem>
          );
        })}
      </SelectedItem>
      <div>
        {targetItemCount === targetItem.length - 1 && targetItemCount !== 0 && (
          <FormItemWrap>
            <FormItemLabel>シリーズ</FormItemLabel>
            <OptionLabel>
              <OptionSelect
                onChange={(e) =>
                  handleSelectedSeries(e.currentTarget.value, targetItemCount)
                }
              >
                <OptionValue value="" hidden>
                  選択してください
                </OptionValue>
                {targetSeries.map((item: any) => (
                  <OptionValue key={`model${item.series}`}>
                    {item.series}
                  </OptionValue>
                ))}
              </OptionSelect>
            </OptionLabel>
          </FormItemWrap>
        )}
        {selectedSeries && (
          <FormItemWrap>
            <FormItemLabel>機種</FormItemLabel>
            <OptionLabel>
              <OptionSelect
                onChange={(e) =>
                  handleSelectedModel(e.currentTarget.value, targetItemCount)
                }
              >
                <OptionValue hidden>選択してください</OptionValue>
                {targetData1?.model.map((item: any) => (
                  <OptionValue key={`model${item.name}`}>
                    {item.name}
                  </OptionValue>
                ))}
              </OptionSelect>
            </OptionLabel>
          </FormItemWrap>
        )}
        {selectedModel && (
          <FormItemWrap>
            <FormItemLabel>容量</FormItemLabel>
            <OptionLabel>
              <OptionSelect
                onChange={(e) =>
                  handleSelectedSpec(e.currentTarget.value, targetItemCount)
                }
              >
                <OptionValue hidden>選択してください</OptionValue>
                {targetSpec1?.spec.map((item: any) => (
                  <OptionValue key={`model${item.gb}`}>{item.gb}</OptionValue>
                ))}
              </OptionSelect>
            </OptionLabel>
          </FormItemWrap>
        )}
        {selectedSpec && (
          <FormItemWrap>
            <FormItemLabel>状態</FormItemLabel>
            <OptionLabel>
              <OptionSelect
                onChange={(e) =>
                  handleSelectedCondition(
                    e.currentTarget.value,
                    targetItemCount
                  )
                }
              >
                <OptionValue hidden>選択してください</OptionValue>
                {condition?.map((item) => (
                  <OptionValue>{getConditionText(item)}</OptionValue>
                ))}
              </OptionSelect>
            </OptionLabel>
          </FormItemWrap>
        )}
      </div>

      <FormItemWrap>
        <FormItemLabel>査定する機種を追加</FormItemLabel>
        <StateItemWrap variant={VariantType.Medium}>
          <AddButton onClick={handleAddCount}>
            <svg
              xmlns="http://www.w3.org/2000/svg"
              height="24"
              viewBox="0 -960 960 960"
              width="24"
            >
              <path d="M450-450H200v-60h250v-250h60v250h250v60H510v250h-60v-250Z" />
            </svg>
            <span>新しく1台追加する</span>
          </AddButton>
        </StateItemWrap>
      </FormItemWrap>
      <FormItemWrap>
        <TitleLabel>
          {/* フリガナ */}
          <FormItemLabel htmlFor="furigana">フリガナ</FormItemLabel>
          <RequiredLabel>※必須</RequiredLabel>
        </TitleLabel>
        <Input
          type="text"
          id="furigana"
          name="furigana"
          variant={VariantType.Medium}
        />
      </FormItemWrap>
      <FormItemWrap>
        <TitleLabel>
          {/* 氏名 */}
          <FormItemLabel htmlFor="name">氏名</FormItemLabel>
          <RequiredLabel>※必須</RequiredLabel>
        </TitleLabel>
        <Input type="text" id="name" name="name" variant={VariantType.Medium} />
      </FormItemWrap>
      <FormItemWrap>
        <TitleLabel>
          {/* メールアドレス */}
          <FormItemLabel htmlFor="email">メールアドレス</FormItemLabel>
          <RequiredLabel>※必須</RequiredLabel>
        </TitleLabel>
        <Input
          type="email"
          id="email"
          name="email"
          variant={VariantType.Medium}
        />
      </FormItemWrap>
      <FormItemWrap>
        <TitleLabel>
          {/* 電話番号 */}
          <FormItemLabel htmlFor="phone_number">電話番号</FormItemLabel>
          <RequiredLabel>※必須</RequiredLabel>
        </TitleLabel>
        <Input
          type="tel"
          id="phone_number"
          name="phone_number"
          variant={VariantType.Medium}
        />
      </FormItemWrap>
      <FormItemWrap>
        <TitleLabel>
          {/* 職業 */}
          <FormItemLabel htmlFor="occupation">職業</FormItemLabel>
          <RequiredLabel>※必須</RequiredLabel>
        </TitleLabel>
        <OptionLabel>
          <OptionSelect id="occupation" name="occupation">
            <OptionValue value="会社役員">会社役員</OptionValue>
            <OptionValue value="公務員">公務員</OptionValue>
            <OptionValue value="自営業/個人事業">自営業/個人事業</OptionValue>
            <OptionValue value="会社員">会社員</OptionValue>
            <OptionValue value="自由業">自由業</OptionValue>
            <OptionValue value="専業主婦・主夫">専業主婦・主夫</OptionValue>
            <OptionValue value="学生">学生</OptionValue>
            <OptionValue value="アルバイト/パート">
              アルバイト/パート
            </OptionValue>
            <OptionValue value="無職">無職</OptionValue>
            <OptionValue value="その他">その他</OptionValue>
          </OptionSelect>
        </OptionLabel>
      </FormItemWrap>
      <FormItemWrap>
        <TitleLabel>
          {/* 年齢 */}
          <FormItemLabel htmlFor="age">年齢</FormItemLabel>
          <RequiredLabel>※必須</RequiredLabel>
        </TitleLabel>
        <OptionLabel>
          <OptionSelect id="age" name="age">
            {ageOptions.map((option) => (
              <OptionValue
                key={option.value}
                value={option.value}
                defaultValue={20}
              >
                {option.label}
              </OptionValue>
            ))}
          </OptionSelect>
        </OptionLabel>
      </FormItemWrap>
      <FormItemWrap>
        <TitleLabel>
          {/* 郵便番号 */}
          <FormItemLabel htmlFor="post_code">
            郵便番号(ハイフンなし)
          </FormItemLabel>
          <RequiredLabel>※必須</RequiredLabel>
        </TitleLabel>
        <Input
          type="text"
          id="post_code"
          name="post_code"
          variant={VariantType.Medium}
        />
      </FormItemWrap>
      <FormItemWrap>
        <FormLabelWrap>
          <TitleLabel>
            {/* 住所 */}
            <FormItemLabel htmlFor="address">住所</FormItemLabel>
            <RequiredLabel>※必須</RequiredLabel>
          </TitleLabel>
          <FormItemSmallLabel>
            ※必ず免許証や本人確認書類と同じ住所を入力してください
          </FormItemSmallLabel>
        </FormLabelWrap>
        <Input
          type="text"
          id="address"
          name="address"
          variant={VariantType.Medium}
        />
      </FormItemWrap>
      <FormItemWrap>
        <div>
          <TitleLabel>
            {/* 集荷希望日 */}
            <FormItemLabel htmlFor="pickup_date">集荷希望日</FormItemLabel>
            <RequiredLabel>※必須</RequiredLabel>
          </TitleLabel>
          <FormItemSmallLabel>※翌日以降をご指定ください</FormItemSmallLabel>
        </div>
        <Input
          type="date"
          id="pickup_date"
          name="pickup_date"
          variant={VariantType.Medium}
        />
      </FormItemWrap>
      <FormItemWrap>
        <div>
          <TitleLabel>
            {/* 集荷希望時間帯 */}
            <FormItemLabel htmlFor="pickup_time">集荷希望時間帯</FormItemLabel>
            <RequiredLabel>※必須</RequiredLabel>
          </TitleLabel>
          <FormItemSmallLabel>
            ※翌日の午後以降をご指定ください
          </FormItemSmallLabel>
        </div>
        <OptionLabel>
          <OptionSelect id="pickup_time" name="pickup_time">
            {pickupTimes.map((option) => (
              <OptionValue key={option} value={option}>
                {option}
              </OptionValue>
            ))}
          </OptionSelect>
        </OptionLabel>
      </FormItemWrap>
      <FormItemWrap>
        <FormLabelWrap>
          <TitleLabel>
            {/* 銀行名 */}
            <FormItemLabel htmlFor="bank_name">銀行名</FormItemLabel>
            <RequiredLabel>※必須</RequiredLabel>
          </TitleLabel>
          <FormItemSmallLabel>
            ※必ず申し込み者と同一名義の口座を入力ください
          </FormItemSmallLabel>
        </FormLabelWrap>
        <Input
          type="text"
          id="bank_name"
          name="bank_name"
          variant={VariantType.Medium}
        />
      </FormItemWrap>
      <FormItemWrap>
        <TitleLabel>
          {/* 支店名 */}
          <FormItemLabel htmlFor="branch_name">支店名</FormItemLabel>
          <RequiredLabel>※必須</RequiredLabel>
        </TitleLabel>
        <Input
          type="text"
          id="branch_name"
          name="branch_name"
          variant={VariantType.Medium}
        />
      </FormItemWrap>
      <FormItemWrap>
        <TitleLabel>
          {/* 預金種目 */}
          <FormItemLabel htmlFor="deposit_type">預金種目</FormItemLabel>
          <RequiredLabel>※必須</RequiredLabel>
        </TitleLabel>
        <OptionLabel>
          <OptionSelect id="deposit_type" name="deposit_type">
            <OptionValue key="normal" value="普通">
              普通
            </OptionValue>
            <OptionValue key="comprehensive" value="総合">
              総合
            </OptionValue>
          </OptionSelect>
        </OptionLabel>
      </FormItemWrap>
      <FormItemWrap>
        <TitleLabel>
          {/* 口座番号 */}
          <FormItemLabel htmlFor="account_number">口座番号</FormItemLabel>
          <RequiredLabel>※必須</RequiredLabel>
        </TitleLabel>
        <Input
          type="number"
          id="account_number"
          name="account_number"
          variant={VariantType.Medium}
        />
      </FormItemWrap>
      <FormItemWrap>
        {/* Lineアカウント名 */}
        <FormItemLabelWrap>
          <FormItemLabel htmlFor="line_account">LINEアカウント名</FormItemLabel>
          <FormItemSmallLabel>
            ※LINEでお問い合わせ頂いた方は入力してください
          </FormItemSmallLabel>
        </FormItemLabelWrap>
        <Input
          type="text"
          id="line_account"
          name="line_account"
          variant={VariantType.Medium}
        />
      </FormItemWrap>
      <FormItemWrap>
        <FormLabelWrap>
          <TitleLabel>
            {/* 身分証1 */}
            <FormItemLabel htmlFor="file1">身分証1</FormItemLabel>
            <RequiredLabel>※必須</RequiredLabel>
          </TitleLabel>
          <FormItemSmallLabel>
            ※免許証等で住所が表面と変更なければ身分証1のみ添付してください
          </FormItemSmallLabel>
        </FormLabelWrap>
        <Input
          type="file"
          id="file1"
          name="file1"
          variant={VariantType.Medium}
        />
      </FormItemWrap>
      <FormItemWrap>
        <FormLabelWrap>
          <TitleLabel>
            {/* 身分証2 */}
            <FormItemLabel htmlFor="file2">身分証2</FormItemLabel>
            <RequiredLabel>※必須</RequiredLabel>
          </TitleLabel>
          <FormItemSmallLabel>
            ※免許証住所裏書などがある場合・保健証の場合住所裏書もしくは住民票の写真が必要となります
          </FormItemSmallLabel>
        </FormLabelWrap>
        <Input
          type="file"
          id="file2"
          name="file2"
          variant={VariantType.Medium}
        />
      </FormItemWrap>
      <FormItemWrap>
        {/* 備考 */}
        <FormItemLabel htmlFor="remarks">備考</FormItemLabel>
        <TextArea id="remarks" name="remarks" maxLength={500} />
      </FormItemWrap>
      <LinkButtonWrap>
        <StyledButton
          type="button"
          id="send"
          onClick={send}
          disabled={isLoading}
          isLoading={isLoading}
        >
          {!isLoading && "送信"}
        </StyledButton>
      </LinkButtonWrap>
    </Section>
  );
});

PurchasedForm.displayName = "PurchasedForm";
